<div
  class="ui attached segment"
  appMargin
  marginT="5"
  style="border: 1px solid #dcdcdc; border-radius: 4px"
  appPadding
  paddingX="40px"
>
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
  >
    <div fxFlex="17">{{ account?.currencyShortName.includes('DOLLAR') ? 'US Dollar' : (account?.currencyShortName | titlecase) }}</div>
    <div fxFlex="17">
      {{ account?.currencyCode }}
      {{ formatAmount(account?.balance ? account?.balance : 0) }}
    </div>
    <div fxFlex="17">
      {{ account?.currencyCode }}
      {{ formatAmount(account?.bookBalance ? account?.bookBalance : 0) }}
    </div>
    <div fxFlex="17">
      <span
        class="ui green circular label"
        [ngClass]="{
          green: account?.status == 'ACTIVE',
          red: account?.status != 'ACTIVE'
        }"
        >{{ account?.status == "ACTIVE" ? "ACTIVE" : "INACTIVE" }}</span
      >
    </div>
    <div fxFlex="18">
      <div
        class="ui segment action_button_segment"
        [ngClass]="{ loading: pending }"
      >
        <button
          class="ui primary button"
          *ngIf="account?.status != 'ACTIVE'"
          (click)="activateAccount()"
        >
          Activate
        </button>
        <div
          class="ui basic primary dropdown"
          *ngIf="account?.status == 'ACTIVE'"
          suiDropdown
        >
          <esl-button
            buttonType="primary"
            buttonSize="small"
            buttonState="outline"
            buttonActionState="default"
            [hasLine]="true"
            [hasSuffixIcon]="true"
            [buttonMenu]="'dropdownMenu'"
            [hasDropdown]="true"
            [isClickable]="true"
          ></esl-button>
          <div class="left menu actions-dropdown" suiDropdownMenu>
            <div class="item" (click)="fundWallet()">Fund eWallet</div>
            <!-- <div class="item" (click)="requestWithdrawal()">
              Request Withdrawals
            </div> -->
            <!-- <div class="item" (click)="viewBankDetails()">
              View Bank Details
            </div>
            <div class="item" (click)="changeBankDetails()">
              Change Bank Details
            </div> -->
            <div class="item" (click)="exportStatement()">
              Export All Transactions Statement
            </div>
            <div class="item" (click)="exportStatementByDate()">
              Export Statement by Date
            </div>
            <button
              class="item close-item ui button"
              style="width: 100%; text-transform: capitalize; border: none;"
              *ngIf="account.balance == 0"
              (click)="closeAccount()"
            >
              Disable {{ account?.currencyShortName.toLowerCase() }} Account
            </button>
          </div>
        </div>
      </div>
    </div>
    <div fxFlex="7" class="text-center">
      <p class="tooltip">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V9H13V7H11ZM11 11V17H13V11H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
            [attr.fill]="account.status == 'ACTIVE' ? '#86879D' : '#DCDCDC'"
          />
        </svg>
        <span class="tooltiptext" *ngIf="account?.status == 'ACTIVE'"
          >Maximum Balance for this account is {{ account.currencyCode
          }}{{ formatAmount(account.maximumWalletAmount) }} and Minimum Amount
          to Fund at a time for this account is {{ account.currencyCode
          }}{{ formatAmount(account.minFundingAmount) }}</span
        >
      </p>
    </div>
    <div fxFlex="7" class="text-right">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        class="eye-icon"
        (click)="goToTransactions()"
      >
        <circle cx="16.5352" cy="16" r="16" fill="#F0F1F8" />
        <path
          d="M16.5348 18.0003C17.8604 18.0003 18.9349 16.9258 18.9349 15.6003C18.9349 14.2747 17.8604 13.2002 16.5348 13.2002C15.2093 13.2002 14.1348 14.2747 14.1348 15.6003C14.1348 16.9258 15.2093 18.0003 16.5348 18.0003Z"
          [attr.fill]="account.status == 'ACTIVE' ? '#86879D' : '#DCDCDC'"
        />
        <path
          d="M25.4994 15.3962C24.7937 13.5707 23.5685 11.9921 21.9754 10.8553C20.3822 9.71855 18.4909 9.07355 16.5352 9C14.5794 9.07355 12.6881 9.71855 11.0949 10.8553C9.50177 11.9921 8.27662 13.5707 7.5709 15.3962C7.52324 15.528 7.52324 15.6724 7.5709 15.8042C8.27662 17.6297 9.50177 19.2083 11.0949 20.3451C12.6881 21.4818 14.5794 22.1268 16.5352 22.2004C18.4909 22.1268 20.3822 21.4818 21.9754 20.3451C23.5685 19.2083 24.7937 17.6297 25.4994 15.8042C25.5471 15.6724 25.5471 15.528 25.4994 15.3962ZM16.5352 19.5003C15.7638 19.5003 15.0097 19.2716 14.3684 18.843C13.727 18.4145 13.2271 17.8053 12.9319 17.0927C12.6367 16.38 12.5595 15.5959 12.71 14.8393C12.8605 14.0828 13.2319 13.3878 13.7774 12.8424C14.3228 12.297 15.0177 11.9255 15.7743 11.775C16.5308 11.6245 17.315 11.7018 18.0277 11.997C18.7403 12.2921 19.3494 12.792 19.778 13.4334C20.2065 14.0748 20.4353 14.8288 20.4353 15.6002C20.4337 16.6341 20.0223 17.6252 19.2912 18.3562C18.5601 19.0873 17.569 19.4987 16.5352 19.5003Z"
          [attr.fill]="account.status == 'ACTIVE' ? '#86879D' : '#DCDCDC'"
        />
      </svg>
    </div>
  </div>
</div>
